// реплики маскота

export const replica_start = "Привет, ну что начнем? Тяни рычаг! Поймай удачу!";
export const replica_win = "Хорошая попытка! Попробуй снова!";
export const replica_fail = "Не удалось? Не унывай! Пробуй снова!";
